import axiosClient from "./axiosClient";

export const misPermisos = () => axiosClient.get("/accesos/mis-permisos").then((r) => r.data);
export const listarAccesos = () => axiosClient.get("/accesos").then((r) => r.data);
export const upsertAcceso = (data) => axiosClient.post("/accesos", data).then((r) => r.data);
export const eliminarAcceso = (id) => axiosClient.delete(`/accesos/${id}`);
